import { workManagementFirstDemoErrorMessage } from './work-management-first-demo-policy.mjs'
import { WORK_MESSAGE_CODES } from './work-message-code-catalog.mjs'

export const WORK_CONFIGURATION_ERROR = '설정 오류가 발생했습니다. 문의 부탁 드립니다'
const UNKNOWN_MESSAGE = '요청을 처리하지 못했습니다. 업무 설정을 확인한 뒤 다시 시도해 주세요.'

// Presentation only: never replace codes used for retries, navigation or acknowledgements.
export const WORK_MESSAGE_TRANSLATIONS = {
  RUNTIME_BRANCH_RPA_INPUT_MAPPING_REQUIRED: '분기 워크플로우의 필수 외부 입력을 선행 할일과 연결해 주세요.',
  RUNTIME_BRANCH_RPA_ITEM_NOT_FOUND: '분기에서 실행할 워크플로우를 찾을 수 없습니다.',
  RUNTIME_BRANCH_RPA_INPUT_SOURCE_NOT_DIRECT_PREDECESSOR: '분기 워크플로우의 입력은 직접 연결된 선행 할일에서 가져와야 합니다.',
  RUNTIME_BRANCH_RPA_INPUT_TYPE_MISMATCH: '분기 워크플로우의 입력 유형과 선행 할일 유형이 일치하지 않습니다.',
  WORK_TEMPLATE_RUNTIME_PUBLISH_FAILED: '업무 템플릿의 실행 설정을 확인한 뒤 다시 발행해 주세요.',
  RUNTIME_DEFINITION_INVALID: '실행 정의의 설정이 올바르지 않습니다.',
  RUNTIME_GRAPH_NEEDS_REVIEW: '발행 전에 실행 규칙의 설정을 검토해 주세요.',
  RUNTIME_DEFINITION_ARCHIVED: '보관된 실행 정의는 발행하거나 수정할 수 없습니다.',
  RUNTIME_TEMPLATE_DEFINITION_OWNERSHIP_INVALID: '실행 정의는 현재 업무 템플릿에 속해야 합니다.',
  RUNTIME_RULE_KEY_RESERVED: '시스템에서 사용하는 예약된 규칙 키는 사용할 수 없습니다.',
  RUNTIME_CONDITION_FUNCTION_UNSUPPORTED: '지원하지 않는 조건 함수입니다.',
  RUNTIME_ACTION_TYPE_UNSUPPORTED: '지원하지 않는 동작 유형입니다.',
  RUNTIME_ACTION_PAYLOAD_FIELD_REQUIRED: '동작 실행에 필요한 필수 항목을 입력해 주세요.',
  RUNTIME_JOIN_CALLBACK_INVALID: '합류 완료 후 실행할 동작은 동작 객체의 배열로 설정해 주세요.',
  RUNTIME_ASSIGNMENT_STRATEGY_UNSUPPORTED: '지원하지 않는 담당자 지정 방식입니다. 조건별 지정은 분기 할일에서 사용할 수 있습니다.',
  RUNTIME_ASSIGNMENT_ORGANIZATION_SUB_IDS_INVALID: '담당 조직을 하나 이상 선택해 주세요.',
  RUNTIME_ASSIGNMENT_MATCH_FIELD_REQUIRED: '담당자를 검색할 기준 항목을 선택해 주세요.',
  RUNTIME_ASSIGNMENT_MATCH_FIELD_UNSUPPORTED: '지원하지 않는 담당자 검색 항목입니다.',
  RUNTIME_ASSIGNMENT_MATCH_OPERATOR_REQUIRED: '담당자 검색의 비교 조건을 선택해 주세요.',
  RUNTIME_ASSIGNMENT_MATCH_OPERATOR_UNSUPPORTED: '지원하지 않는 담당자 검색 비교 방식입니다. 비교 조건을 다시 선택해 주세요.',
  RUNTIME_ASSIGNMENT_MULTIPLE_MATCHES: '검색 조건에 여러 대상이 일치하여 모두 할당했습니다. 할당 결과를 확인해 주세요.',
  RUNTIME_ASSIGNMENT_NO_MATCH: '검색 조건에 일치하는 담당자가 없습니다.',
  RUNTIME_ASSIGNMENT_FIXED_TARGET_UNAVAILABLE: '지정한 담당자를 현재 할당할 수 없습니다.',
  RUNTIME_ASSIGNMENT_NO_APPLICABLE_CONDITION: '현재 분류값에 적용되는 담당 조건이 없습니다.',
  RUNTIME_DISPATCH_VALUE_FROM_REQUIRED: '파일 분류에 사용할 원본 값을 지정해 주세요.',
  RUNTIME_DISPATCH_MATCH_POLICY_UNSUPPORTED: '분기 분류는 처음 일치하는 조건을 적용하는 방식만 지원합니다.',
  RUNTIME_DISPATCH_CASE_OPERATOR_UNSUPPORTED: '분류 조건의 비교 방식을 확인해 주세요. 포함 비교는 파일 분류에서만 사용할 수 있습니다.',
  RUNTIME_DISPATCH_BRANCH_TEMPLATE_NOT_FOUND: '분류 조건이 참조하는 분기 템플릿을 찾을 수 없습니다.',
  RUNTIME_DISPATCH_CASE_VALUE_STRING_REQUIRED: '포함 비교의 분류값은 문자열로 입력해 주세요.',
  RUNTIME_DISPATCH_CASE_VALUE_INVALID: '분류값은 문자열, 숫자 또는 참·거짓 값으로 입력해 주세요.',
  RUNTIME_DISPATCH_VALUE_OVERLAPPED: '앞선 분류 조건에 같은 값이 있습니다. 중복 값을 제거하거나 조건 순서를 변경해 주세요.',
  RUNTIME_DISPATCH_DEFAULT_INVALID: '기본 분기 설정에 분기 템플릿을 지정하거나 기본 분기 설정을 비워 주세요.',
  RUNTIME_DISPATCH_COMPLETION_EMPTY_POLICY_CONFLICT: '분류 결과가 없을 때의 처리 방식과 완료 합류의 처리 방식을 일치시켜 주세요.',
  RUNTIME_CREATE_BRANCH_TEMPLATE_NOT_FOUND: '분기 생성 동작이 참조하는 분기 템플릿을 찾을 수 없습니다.',
  RUNTIME_DISPATCH_CREATE_BRANCH_ACTION_DUPLICATED: '분류 대상에는 조건 없이 실행하는 분기 생성 동작이 정확히 하나 있어야 합니다.',
  RUNTIME_JOIN_TARGET_MISSING: '합류 대상 할일 또는 완료 동작을 지정해 주세요.',
  RUNTIME_JOIN_OBSERVE_UNSUPPORTED: '지원하지 않는 합류 감지 방식입니다.',
  RUNTIME_JOIN_OUTPUT_SELECTOR_MISSING: '결과물 생성 여부를 확인하는 합류에는 결과물 선택 조건을 지정해 주세요.',
  RUNTIME_OUTPUT_SELECTION_MODE_UNSUPPORTED: '지원하지 않는 결과물 선택 방식입니다.',
  RUNTIME_REVIEW_SOURCE_OBJECT_REQUIRED: '분기 검토의 원본 설정을 입력해 주세요.',
  RUNTIME_REVIEW_SOURCE_LOCATION_NON_CANONICAL: '검토 원본 설정을 입력 설정 내부로 이동해 주세요.',
  RUNTIME_REVIEW_SOURCE_DISPATCH_KEY_REQUIRED: '검토 원본으로 사용할 분류 규칙의 키를 지정해 주세요.',
  RUNTIME_REVIEW_SOURCE_DISPATCH_NOT_FOUND: '검토 원본으로 지정한 분류 규칙을 찾을 수 없습니다.',
  RUNTIME_REVIEW_SOURCE_DISPATCH_FILE_REQUIRED: '검토 원본에는 파일을 분류하는 규칙을 지정해 주세요.',
  RUNTIME_REVIEW_SOURCE_DISPATCH_TEMPLATE_MISMATCH: '검토 원본의 분류 규칙이 현재 분기 템플릿을 대상으로 하지 않습니다.',
  RUNTIME_REVIEW_SOURCE_DISPATCH_ROOT_REQUIRED: '분류된 파일은 분기의 첫 검토 할일에서만 원본으로 사용할 수 있습니다.',
  RUNTIME_REVIEW_SOURCE_TYPE_INVALID: '지원하지 않는 검토 원본 유형입니다.',
  RUNTIME_REVIEW_SOURCE_ITEM_KEY_REQUIRED: '검토 원본 할일의 키를 지정해 주세요.',
  RUNTIME_REVIEW_SOURCE_RUN_SELECTOR_INVALID: '검토할 실행 회차의 선택 조건을 확인해 주세요.',
  RUNTIME_REVIEW_SOURCE_OUTPUT_SELECTOR_NON_CANONICAL: '기존 문자열 방식의 결과물 선택 조건을 객체 형식으로 변경해 주세요.',
  RUNTIME_REVIEW_SOURCE_OUTPUT_SELECTOR_INVALID: '검토할 결과물의 선택 조건을 확인해 주세요.',
  RUNTIME_RUN_REVIEW_REQUIRED_FLAG_INVALID: '필수 검토 여부는 참 또는 거짓으로 설정해 주세요.',
  RUNTIME_RUN_REVIEW_TIMEOUT_INVALID: '검토 제한 시간은 양수로 입력하고, 시간 초과 시 취소 또는 통과를 선택해 주세요.',
  RUNTIME_RUN_REVIEW_JOIN_SOURCE_AMBIGUOUS: '필수 검토 할일에 여러 합류 원본이 연결되어 있습니다.',
  RUNTIME_RUN_REVIEW_OUTPUT_COVERAGE_EMPTY: '필수 검토 할일에 검토할 결과물이 지정되어 있지 않습니다.',
  RUNTIME_RUN_REVIEW_OUTPUT_COVERAGE_GAP_POSSIBLE: '필수 검토 범위에 선택한 실행 회차의 일부 결과물이 빠져 있을 수 있습니다.',
  RUNTIME_RUN_REVIEW_OUTPUT_COVERAGE_OVERLAP: '필수 검토 할일 사이에 검토 대상 결과물이 중복됩니다.',
  RUNTIME_RUN_REVIEW_REQUIRED_READ_MISSING: '이 승인 정책에는 필수 검토 할일이 하나 이상 필요합니다.',
  RUNTIME_RUN_REVIEW_ANY_APPROVED_OPTION_REQUIRED: '일부 승인 후 나머지 검토는 취소 또는 검토 불필요로 설정해 주세요.',
  RUNTIME_RUN_REVIEW_DESIGNATED_READ_INVALID: '승인 기준으로 사용할 필수 검토 할일을 지정해 주세요.',
  RUNTIME_SCHEMA_VERSION_UNSUPPORTED: '지원하지 않는 실행 정의 형식의 버전입니다.',
  WORK_PUBLISH_IDEMPOTENCY_CONFLICT: '이전 발행 요청과 입력 내용이 다릅니다. 최신 상태를 확인한 뒤 다시 발행해 주세요.',
  WORK_PERIOD_KEY_REQUIRED: '주기형 업무의 발행 회차를 지정해 주세요.',
  WORK_ALREADY_PUBLISHED: '이미 발행된 업무 회차입니다.',
  CAPABILITY_NOT_PROVIDED: '이 작업을 수행할 권한을 확인할 수 없습니다.',
  RUNTIME_SIMULATION_API_NOT_AVAILABLE: '현재 시뮬레이션 기능을 사용할 수 없습니다.',
  RUNTIME_ASSIGNMENT_UNRESOLVED: '담당자를 결정하지 못했습니다. 담당 조건과 프로젝트 소속을 확인해 주세요.',
  RUNTIME_DEFINITION_DRAFT_CONFLICT: '실행 정의의 초안이 변경되었습니다. 최신 초안을 다시 불러와 주세요.',
  RUNTIME_DEFINITION_ALIAS_CONFLICT: '같은 항목의 별칭과 정식 이름을 함께 사용할 수 없습니다.',
  RUNTIME_DEFINITION_HASH_MISMATCH: '실행 정의가 발행된 버전과 일치하지 않습니다.',
  RUNTIME_GRAPH_DRAFT_INVALID: '실행 정의 초안의 구조가 올바르지 않습니다.',
  RUNTIME_BRANCH_DAG_CYCLE: '분기 할일의 연결에 순환이 있습니다. 연결 구성을 확인해 주세요.',
  RUNTIME_BRANCH_TEMPLATE_NODE_ISOLATED: '분기 템플릿에 다른 할일과 연결되지 않은 할일이 있습니다.',
  RUNTIME_BRANCH_EDGE_REFERENCE_INVALID: '분기의 연결은 같은 템플릿 안의 할일을 참조해야 합니다.',
  RUNTIME_DISPATCH_EMPTY: '분류 조건에 해당하는 값이 없습니다.',
  RUNTIME_ITERATION_EMPTY: '분기 템플릿을 실행할 원본이 하나 이상 필요합니다.',
  RUNTIME_DISPATCH_COLUMN_SELECTOR_REQUIRED: '분류할 열의 위치 또는 이름을 지정해 주세요.',
  RUNTIME_DISPATCH_COLUMN_SELECTOR_CONFLICT: '분류할 열은 하나의 선택 방식으로 지정해 주세요.',
  RUNTIME_DISPATCH_SOURCE_RUN_CONFLICT: '파일 분류의 원본은 같은 실행 회차에서 가져와야 합니다.',
  RUNTIME_DISPATCH_CREATE_BRANCH_ACTION_REQUIRED: '분류 대상에 분기 생성 동작을 추가해 주세요.',
  RUNTIME_BRANCH_TIMEOUT_MISSING: '반복 실행하는 분기에는 제한 시간을 설정해 주세요.',
  RUNTIME_BRANCH_ON_NO_MATCH_MISSING: '완료 규칙의 조건에 일치하지 않을 때의 처리 방식을 설정해 주세요.',
  RUNTIME_COMPLETION_JOIN_EMPTY: '완료 합류의 대상이 되는 분기가 생성되지 않았습니다.',
  RUNTIME_BRANCH_COMPLETION_PREREQUISITES_NOT_MET: '분기 실행의 필수 검토를 완료해 주세요.',
  RUNTIME_REVIEW_TARGET_NOT_AVAILABLE: '검토 가능한 대상 결과물이 없습니다.',
  RUNTIME_REVIEW_ATTEMPT_STALE: '현재 검토 회차가 변경되었거나 활성 상태가 아닙니다. 최신 상태를 확인해 주세요.',
  RUNTIME_REVIEW_PREDECESSOR_AMBIGUOUS: '완료된 선행 검토 할일이 여러 개입니다. 검토 원본을 명확히 지정해 주세요.',
  RUNTIME_RUN_REVIEW_IMMUTABLE: '확정된 실행 검토 결과는 변경할 수 없습니다.',
  RUNTIME_RUN_REVIEWER_REQUIRED: '실행 검토 담당자 또는 프로젝트 관리자 권한이 필요합니다.',
  RUNTIME_REQUIRED_REVIEW_NOT_CONFIGURED: '필수 검토 할일을 하나 이상 지정해 주세요.',
  RUNTIME_NODE_NOT_RETRYABLE: '실패한 실행 항목만 재시도할 수 있습니다.',
  RUNTIME_EXECUTION_NOT_RETRYABLE: '실패하거나 일부만 성공한 실행만 재시도할 수 있습니다.',
  RUNTIME_EXECUTION_NOT_CANCELABLE: '대기 중이거나 진행 중인 실행만 취소할 수 있습니다.',
  RUNTIME_EXECUTION_LEASE_EXPIRED: '실행 처리 시간이 만료되었습니다. 실행 상태를 확인해 주세요.',
  RUNTIME_EXECUTION_WITHDRAWN: '실행에 사용된 입력이 철회되었습니다.',
  RUNTIME_JOIN_WITHDRAWN: '합류에 사용된 입력이 철회되었습니다.',
  RUNTIME_ACTION_RPA_STALE_RECONCILIATION_REQUIRED: '워크플로우 실행 요청의 상태를 확인하고 복구해 주세요.',
  RUNTIME_ACTION_RPA_HISTORY_OUTPUT_NOT_AVAILABLE: '완료된 워크플로우 실행 이력에서 재사용할 결과물을 찾을 수 없습니다.',
  RUNTIME_ACTION_FAILED: '실행 동작을 완료하지 못했습니다.',
  RUNTIME_ACTION_HANDLER_NOT_REGISTERED: '이 동작 유형을 처리할 실행 기능이 등록되어 있지 않습니다.',
  RUNTIME_SOURCE_NOT_AVAILABLE: '설정한 원본을 찾을 수 없거나 접근할 수 없습니다.',
  RUNTIME_SOURCE_LINEAGE_INVALID: '실행 원본과 결과물의 연결 이력이 올바르지 않습니다.',
  RUNTIME_SIMULATION_SOURCE_NOT_AVAILABLE: '시뮬레이션 원본을 사용할 수 없습니다.',
  RUNTIME_SIMULATION_SOURCE_EMPTY: '시뮬레이션 원본을 선택해 주세요.',
  RUNTIME_SIMULATION_SOURCE_MAPPING_AMBIGUOUS: '시뮬레이션 원본과 입력의 연결을 명확히 지정해 주세요.',
  RUNTIME_SIMULATION_ALREADY_FINISHED: '완료된 시뮬레이션의 상태는 변경할 수 없습니다.',
  RUNTIME_TEMPLATE_REFERENCES_UNRESOLVED: '대상 프로젝트에서 선택할 수 없는 참조가 있습니다. 연결 설정을 확인해 주세요.',
  RUNTIME_TEMPLATE_CROSS_PROJECT_RPA_COPY_REQUIRED: '다른 프로젝트로 템플릿을 복사할 때는 워크플로우도 함께 복사해야 합니다.',
  RUNTIME_TEMPLATE_RPA_COPY_FAILED: '워크플로우 복사 결과를 확인할 수 없습니다.',
  RUNTIME_LATEST_SUCCESS_INCLUDES_REJECTED: '업무 승인이 필요한 경우 최신 승인된 실행을 원본으로 선택해 주세요.',
  WORK_ARCHIVED: '보관된 업무는 조회만 할 수 있습니다.',
  WORK_DELETE_CONFLICT: '보호되는 이력이 있어 업무를 삭제할 수 없습니다.',
  WORK_REVIEW_TARGET_NOT_READY: '검토 대상 결과물이 아직 준비되지 않았습니다.',
  WORK_REVIEW_SOURCE_AMBIGUOUS: '검토 원본에 해당하는 선행 워크플로우가 여러 개입니다.',
  WORK_BRANCH_FLOW_SNAPSHOT_INVALID: '발행된 분기 흐름의 저장 정보가 올바르지 않습니다.',
  WORK_FLOW_SNAPSHOT_INVALID: '발행된 업무 흐름의 저장 정보가 올바르지 않습니다.',
  BRANCH_MAX_ATTEMPTS_REACHED: '분기의 최대 실행 회차에 도달했습니다.',
  BRANCH_COMPLETE_PERMISSION_REQUIRED: '분기를 완료하려면 템플릿 발행 권한과 분기 흐름 조회 권한이 필요합니다.',
  WORK_INPUT_WITHDRAWAL_LINEAGE_UNAVAILABLE: '입력의 사용 이력을 확인할 수 없어 철회할 수 없습니다.',
  WORK_ITEM_SYSTEM_AUTO_STATUS_CHANGE_NOT_ALLOWED: '진행 중인 자동 실행 항목은 반려하거나 수정 요청할 수 없습니다.',
  WORK_APPROVAL_SEAL_IMMUTABLE: '확정된 승인 정보는 변경할 수 없습니다.',
  WORK_ASSIGNMENT_ATTEMPT_INVALID: '담당자를 지정할 할일 회차가 올바르지 않거나 철회되었습니다.',
  WORK_ASSIGNMENT_EVENT_IMMUTABLE: '담당자 지정 이벤트는 변경할 수 없습니다.',
  WORK_ASSIGNMENT_IMMUTABLE: '담당자 지정 이력은 변경할 수 없습니다. 취소 처리를 이용해 주세요.',
  WORK_ITEM_SYSTEM_AUTO_ATTEMPT_STALE: '자동 실행 요청의 회차가 변경되었습니다. 최신 상태를 확인해 주세요.',
  WORK_ITEM_SYSTEM_AUTO_DISPATCH_FAILED: '자동 실행 요청을 처리하지 못했습니다. 업무 발행자와 실행 상태를 확인해 주세요.',
  WORK_ITEM_AUTO_RETRY_INPUT_NOT_READY: '자동 재시도의 입력이 이전에 확인한 입력과 일치하지 않습니다.',
  RUNTIME_BRANCH_WORK_ITEM_KEY_INVALID: '분기의 할일 키를 빠짐없이 입력하고 서로 다른 키를 사용해 주세요.',
  RUNTIME_EXECUTION_MODE_REQUIRED: '할일 실행 방식을 지정해 주세요.',
  RUNTIME_BRANCH_ACCUMULATOR_LINEAGE_INVALID: '분기 누적값의 원본 데이터 또는 현재 회차의 실행 이력이 올바르지 않습니다.',
  RUNTIME_BRANCH_ACCUMULATOR_UNSUPPORTED: '지원하지 않는 분기 누적 연산입니다.',
  RUNTIME_BRANCH_ACCUMULATOR_OPERATION_UNSUPPORTED: '분기 누적 연산은 합계 또는 개수를 선택해 주세요.',
  RUNTIME_BRANCH_ACCUMULATOR_OBJECT_REQUIRED: '분기 완료 시 누적값 설정은 객체로 입력해 주세요.',
  RUNTIME_BRANCH_OUTCOME_UNSUPPORTED: '지원하지 않는 분기 완료 결과입니다.',
  RUNTIME_BRANCH_CYCLE_REOPEN_MODE_UNSUPPORTED: '지원하지 않는 분기 회차 재개 방식입니다.',
  RUNTIME_BRANCH_CYCLE_REOPEN_POLICY_OBJECT_REQUIRED: '분기 회차 재개 정책은 객체로 입력해 주세요.',
  BRANCH_INSTANCE_HASH_COLLISION: '분기 식별 정보가 충돌했습니다. 분기 생성 설정을 확인해 주세요.',
  RUNTIME_REVIEW_SOURCE_DISPATCH_CONTEXT_MISMATCH: '현재 분기가 검토 원본으로 지정한 분류 규칙에 속하지 않습니다.',
  RUNTIME_BRANCH_JOIN_RECONCILIATION_FAILED: '분기 합류 상태를 갱신하지 못해 다시 시도할 예정입니다.',
  RUNTIME_BRANCH_PRESENTATION_NAME_TEMPLATE_INVALID: '분기 이름 형식에 지원하지 않는 항목이 있습니다.',
  RUNTIME_BRANCH_PRESENTATION_OBJECT_REQUIRED: '분기 표시 설정은 객체로 입력해 주세요.',
  RUNTIME_BRANCH_PRESENTATION_SOURCE_UNSUPPORTED: '분기 표시 이름의 원본은 분류값만 사용할 수 있습니다.',
  RUNTIME_BRANCH_ACCUMULATOR_VALUE_INVALID: '분기 합계 누적에는 숫자만 사용할 수 있습니다.',
  RUNTIME_ASSIGNMENT_AMBIGUOUS: '고정 담당자와 담당자 지정 조건 중 한 가지 방식을 선택해 주세요.',
  RUNTIME_COMPLETION_JOIN_INVALID: '완료 합류 설정은 객체로 입력해 주세요.',
  RUNTIME_CONDITION_INVALID: '조건 설정은 객체로 입력해 주세요.',
  RUNTIME_SIMULATION_SOURCE_SELECTION_INVALID: '시뮬레이션 원본 선택 정보의 형식이 올바르지 않습니다.',
  RUNTIME_NODE_EXECUTION_REQUIRED: '업무 실행 항목에 연결된 실행인지 확인해 주세요.',
  WORK_TEMPLATE_ASSIGNEES_INVALID: '담당자 지정 정보가 올바르지 않습니다.',
  RUNTIME_ITERATION_VALUE_INVALID: '반복값은 문자열, 숫자 또는 참·거짓 값으로 입력해 주세요.',
  RUNTIME_DISPATCH_KEY_RESERVED: '시스템에서 사용하는 예약된 분류 규칙 키는 사용할 수 없습니다.',
  RUNTIME_RUN_STATUS_INVARIANT_VIOLATION: '기존 실행 상태를 현재 실행·검토 상태로 변환할 수 없습니다.',
  WORK_REVIEW_SOURCE_INVALID: '최신 파일 입력을 검토하려면 파일 입력 할일을 원본으로 선택해 주세요.',
  RUNTIME_OFFICIALIZATION_IDEMPOTENCY_CONFLICT: '같은 공식 지정 요청에 서로 다른 결과물이 선택되었습니다.',
  WORK_WITHDRAWAL_IMMUTABLE: '철회 이력은 변경할 수 없습니다.',
  WORK_RUN_REVIEW_STATUS_INVALID: '검토 중인 실행 회차만 승인하거나 반려할 수 있습니다.',
  RUNTIME_OUTPUT_SELECTOR_COLUMN_INVALID: '결과물 선택 열의 위치는 0 이상의 정수로 입력해 주세요.',
  RUNTIME_OUTPUT_SELECTOR_CELL_NOT_AVAILABLE: '결과물에서 지정한 셀을 사용할 수 없습니다.',
  RUNTIME_OUTPUT_SELECTOR_TABLE_NOT_AVAILABLE: '결과물에서 지정한 테이블을 사용할 수 없습니다.',
  RUNTIME_DEFINITION_OWNED_MUTATION_NOT_ALLOWED: '템플릿에 속한 실행 정의는 해당 업무 템플릿에서 수정해 주세요.',
  RUNTIME_DEFINITION_VERSION_IMMUTABLE: '발행된 실행 정의 버전은 변경할 수 없습니다.',
  WORK_RULE_BRANCH_FLOW_IDENTITY_INVALID: '발행된 규칙의 분기 흐름 식별 정보가 올바르지 않습니다.',
  RUNTIME_BRANCH_RUN_ATTEMPT_STALE: '워크플로우 결과가 현재 진행 중인 분기 회차에 속하지 않습니다.',
  RUNTIME_OFFICIAL_OUTPUT_REPRESENTATIVE_INVALID: '대표 결과물은 공식 지정할 결과물에 포함되어야 합니다.',
  WORK_ASSIGNMENT_CHANGE_KEY_CONFLICT: '이전 담당자 변경 요청과 입력 내용이 다릅니다. 최신 상태를 확인해 주세요.',
  RUNTIME_RUN_REVIEW_PREMATURE_FINALIZATION: '실행이 이미 확정되어 필요한 후속 검토를 진행할 수 없습니다.',
  RUNTIME_RUN_SELECTOR_UNSUPPORTED: '지원하지 않는 실행 회차 선택 방식입니다.',
  WORK_FORM_SCHEMA_CONFLICT: '폼 구조 또는 입력 회차가 변경되었습니다. 최신 설정을 확인해 주세요.',
  RUNTIME_RUN_REVIEW_ATTEMPT_STALE: '검토할 실행이 현재 진행 중인 분기 회차에 속하지 않습니다.',
  RUNTIME_WORK_ITEM_TREE_MUTATION_PROTECTED: '실행 분기의 할일은 일반 업무 흐름에서 변경할 수 없습니다.',
  RUNTIME_DEFINITION_DELETE_NOT_ALLOWED: '실행 정의는 삭제할 수 없습니다. 보관 처리를 이용해 주세요.',
  RUNTIME_EXECUTION_CANCELED: '사용자가 실행을 취소했습니다.',
  RUNTIME_WORK_STATUS_TRANSITION_INVALID: '현재 업무 상태에서는 요청한 상태로 변경할 수 없습니다.',
  RUNTIME_EXECUTION_MODE_UNSUPPORTED: '지원하지 않는 할일 실행 방식입니다.',
  RUNTIME_NODE_EVENT_IDEMPOTENCY_CONFLICT: '같은 실행 항목 이벤트 요청에 서로 다른 내용이 전달되었습니다.',
  RUNTIME_NODE_EVENT_TYPE_INVALID: '지원하지 않는 실행 항목 이벤트 유형입니다.',
  RUNTIME_NODE_GENERATION_CONFLICT: '실행 항목의 처리 회차가 변경되었습니다. 최신 상태를 확인해 주세요.',
  RUNTIME_NODE_RECONCILIATION_FAILED: '실행 항목의 상태를 갱신하지 못해 다시 시도할 예정입니다.',
  RUNTIME_SNAPSHOT_IMMUTABLE: '저장된 실행 시점의 정보는 변경할 수 없습니다.',
  RUNTIME_SYSTEM_RPA_MANUAL_RUN_NOT_ALLOWED: '자동 실행 워크플로우는 시스템에서만 실행할 수 있습니다.',
  RUNTIME_RPA_STATUS_MUTATION_NOT_ALLOWED: '자동 관리되는 워크플로우 상태는 해당 실행 화면에서 변경해 주세요.',
  RUNTIME_REVIEW_STATUS_MUTATION_NOT_ALLOWED: '자동 관리되는 검토 상태는 해당 검토 화면에서 처리해 주세요.',
  RUNTIME_RUN_REVIEW_ENDPOINT_NOT_ALLOWED: '자동 관리되는 실행은 해당 할일 또는 실행 검토 화면에서 검토해 주세요.',
  RUNTIME_OFFICIALIZATION_ENDPOINT_NOT_ALLOWED: '자동 관리되는 실행의 공식 결과는 해당 실행의 공식 지정 기능에서 처리해 주세요.',
  RUNTIME_OFFICIAL_OUTPUT_SELECTION_INVALID: '해당 실행에서 승인된 후보 결과물만 공식 결과로 선택할 수 있습니다.',
  WORK_ITEM_MAIN_FLOW_AUTO_DISPATCH_PROTECTED: '시스템에서 관리하는 업무 흐름의 자동 실행 정보는 변경할 수 없습니다.',
  RUNTIME_WORK_ITEM_EXTRA_FIELDS_PROTECTED: '시스템에서 관리하는 할일의 추가 정보는 변경할 수 없습니다.',
  WORK_ITEM_AUTO_RETRY_SELF_REJECTION_NOT_ALLOWED: '자동 실행 할일은 자신을 반려할 수 없습니다.',
  RUNTIME_TEMPLATE_COPY_COMMAND_INVALID: '템플릿 복사 요청의 형식이 올바르지 않습니다.',
  RUNTIME_TEMPLATE_COPY_EDGE_INVALID: '템플릿 연결이 참조하는 항목을 찾을 수 없습니다.',
  WORK_TEMPLATE_TIMEZONE_INVALID: '템플릿의 시간대 설정이 올바르지 않습니다.',
  RUNTIME_BRANCH_ATTEMPT_CONFLICT: '분기 할일의 현재 회차 또는 완료 상태가 변경되었습니다. 최신 상태를 확인해 주세요.',
  RUNTIME_MTD_CELL_NOT_AVAILABLE: '설정한 데이터 셀을 사용할 수 없습니다.',
  RUNTIME_MTD_SOURCE_AMBIGUOUS: '설정한 데이터 원본을 하나로 결정할 수 없습니다.',
  RUNTIME_DEFINITION_OWNER_PROJECT_MISMATCH: '업무 템플릿과 실행 정의는 같은 프로젝트에 속해야 합니다.',
  RUNTIME_EXECUTION_IDEMPOTENCY_CONFLICT: '같은 실행 요청에 서로 다른 입력이 전달되었습니다.',
  RUNTIME_CATALOG_VERSION_UNSUPPORTED: '지원하지 않는 실행 기능 목록의 버전입니다.',
  RUNTIME_RPA_JSON_INVALID: '선택한 워크플로우의 정의가 올바르지 않습니다.',
  WORK_ITEM_STATUS_NOT_ALLOWED: '현재 방식으로는 할일 상태를 변경할 수 없습니다.',
  RUNTIME_REFERENCE_RESOURCE_TYPE_INVALID: '지원하지 않는 참조 리소스 유형입니다.',
  RUNTIME_JOIN_TARGET_INPUT_MUTATION_NOT_ALLOWED: '합류를 기다리는 할일은 활성화된 후 입력할 수 있습니다.',
  WORK_WITHDRAWAL_CONFIG_INVALID: '철회를 지원하는 할일 유형과 철회 허용 여부를 확인해 주세요.',
  WORK_NOTIFICATION_PROJECT_INVALID: '업무 알림의 참조 항목은 같은 프로젝트에 속해야 합니다.',
  WORK_ITEM_EXECUTION_MODE_UNSUPPORTED: '지원하지 않는 할일 실행 방식입니다.',
}

const ENGLISH_MESSAGES = {
  'Archived Definitions cannot start a new Simulation.': '보관된 실행 정의로는 새 시뮬레이션을 시작할 수 없습니다.',
  'Project user matching only supports equals.': '이 담당자 검색 방식은 일치 비교만 지원합니다.',
  'Runtime Branch RPA external input mapping is required.': WORK_MESSAGE_TRANSLATIONS.RUNTIME_BRANCH_RPA_INPUT_MAPPING_REQUIRED,
  'Runtime Branch RPA item was not found.': WORK_MESSAGE_TRANSLATIONS.RUNTIME_BRANCH_RPA_ITEM_NOT_FOUND,
  'RPA input source must be a direct predecessor in the Branch DAG.': WORK_MESSAGE_TRANSLATIONS.RUNTIME_BRANCH_RPA_INPUT_SOURCE_NOT_DIRECT_PREDECESSOR,
  'RPA input source WorkItem type is incompatible.': WORK_MESSAGE_TRANSLATIONS.RUNTIME_BRANCH_RPA_INPUT_TYPE_MISMATCH,
  'Work Template Runtime publish validation failed.': WORK_MESSAGE_TRANSLATIONS.WORK_TEMPLATE_RUNTIME_PUBLISH_FAILED,
  'Network Error': '서버에 연결하지 못했습니다. 네트워크 상태를 확인해 주세요.',
  'Failed to fetch': '서버에서 데이터를 불러오지 못했습니다.',
  'Engine unavailable.': '워크플로우 실행 엔진을 사용할 수 없습니다.',
  'Permission denied.': '이 작업을 수행할 권한이 없습니다.',
  'Authentication credentials were not provided.': '로그인 정보가 없습니다. 다시 로그인해 주세요.',
  'Not found.': '요청한 데이터를 찾을 수 없습니다.',
  'Internal Server Error': '서버에서 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
}

const TERMS = [
  [/Runtime Definition/gi, '실행 정의'], [/Runtime Branch/gi, '실행 분기'], [/Runtime Execution/gi, '업무 실행'],
  [/Branch Flow/gi, '분기 흐름'], [/Work tree/gi, '업무 흐름'], [/WorkItem/gi, '할일'],
  [/RuleRun/gi, '규칙 실행'], [/ActionRun/gi, '동작 실행'], [/JoinState/gi, '합류 상태'],
  [/needs_review/g, '검토 필요'], [/pending, in_progress, revision_requested/g, '대기, 진행 중, 수정 요청'],
  [/\bRuntime\b/gi, '실행'], [/\bBranch\b/gi, '분기'], [/\bRule\b/gi, '규칙'], [/\bWork\b/g, '업무'],
  [/\bDraft\b/gi, '초안'], [/\bVersion diff\b/gi, '버전 차이'], [/\bVersion\b/gi, '버전'],
  [/\bSimulation\b/gi, '시뮬레이션'], [/\bCycle\b/g, '회차'], [/\bJoin\b/g, '합류'],
  [/\bSample\b/g, '샘플'], [/\bSource\b/g, '원본'], [/\bOutput\b/gi, '출력'], [/\bInput\b/gi, '입력'],
  [/\bForm\b/g, '폼'], [/\bWarning\b/gi, '경고'], [/\bError\b/g, '오류'],
]

export function canViewWorkMessageDetails(permissionLevel) {
  return permissionLevel !== null && permissionLevel !== '' && Number.isFinite(Number(permissionLevel)) && Number(permissionLevel) >= 2
}

function localizedCode(code) {
  if (WORK_MESSAGE_TRANSLATIONS[code]) return WORK_MESSAGE_TRANSLATIONS[code]
  const known = workManagementFirstDemoErrorMessage({}, code)
  if (known) return known
  // Stable code families cover newly added validation diagnostics without showing English.
  const subject = [
    ['RUNTIME_BRANCH_TEMPLATE', '분기 템플릿'], ['RUNTIME_BRANCH_DISPATCH', '분류 규칙'],
    ['RUNTIME_RESOURCE_SOURCE', '원본 리소스'], ['RUNTIME_WORK_ITEM', '할일'], ['RUNTIME_ACTION', '실행 동작'],
    ['RUNTIME_ASSIGNMENT', '담당자 지정'], ['RUNTIME_DISPATCH', '분류'], ['RUNTIME_RULE', '규칙'],
    ['RUNTIME_JOIN', '합류'], ['RUNTIME_REVIEW', '검토'], ['RUNTIME_DEFINITION', '실행 정의'],
  ].find(([prefix]) => code.startsWith(prefix))?.[1]
  if (subject) {
    if (code.endsWith('_KEY_DUPLICATED')) return `${subject}의 키가 중복됩니다. 서로 다른 키를 사용해 주세요.`
    if (code.endsWith('_KEY_REQUIRED')) return `${subject}의 키를 입력해 주세요.`
    if (code.endsWith('_ARRAY_REQUIRED')) return `${subject} 설정의 해당 항목은 배열로 입력해 주세요.`
    if (code.endsWith('_OBJECT_REQUIRED')) return `${subject} 설정의 해당 항목은 객체로 입력해 주세요.`
    if (code.endsWith('_BOOLEAN_REQUIRED')) return `${subject} 설정의 해당 항목은 참 또는 거짓으로 입력해 주세요.`
    if (code.endsWith('_UNSUPPORTED')) return `${subject} 설정에 지원하지 않는 값이 있습니다. 설정을 확인해 주세요.`
    if (code.endsWith('_REQUIRED')) return `${subject} 설정에 필수 항목이 누락되었습니다. 설정을 확인해 주세요.`
    if (code.endsWith('_INVALID')) return `${subject} 설정에 올바르지 않은 값이 있습니다. 설정을 확인해 주세요.`
  }
  if (/_ACCESS_DENIED$|_FORBIDDEN$|_PERMISSION_DENIED$/.test(code)) return '이 작업을 수행할 권한이 없습니다.'
  if (/_VERSION_CONFLICT$|_STATE_CONFLICT$/.test(code)) return '설정 또는 상태가 변경되었습니다. 최신 내용을 다시 불러와 주세요.'
  if (/_NOT_FOUND$/.test(code)) return '요청한 항목을 찾을 수 없습니다. 최신 내용을 다시 불러와 주세요.'
  return ''
}

function translate(value) {
  if (!value) return UNKNOWN_MESSAGE
  if (typeof value === 'object') {
    const payload = value.response?.data || value
    const error = payload.error || payload
    const message = error.message || error.detail || error.err_msg || ''
    if (typeof message === 'string' && /[가-힣]/.test(message)) return translate(message)
    return translate(ENGLISH_MESSAGES[message] || localizedCode(error.code || error.error_code || '') || message || error.reason_code || '')
  }
  const message = String(value).trim()
  if (/^[{[]/.test(message)) {
    try { return translate(JSON.parse(message)) } catch { /* A plain message can start with a bracket. */ }
  }
  const code = message.match(/\b(?:RUNTIME|WORK|RPA|BRANCH|JOIN|CAPABILITY)_[A-Z_]+\b/)?.[0]
  let result = ENGLISH_MESSAGES[message] || (/[가-힣]/.test(message) ? message : localizedCode(WORK_MESSAGE_CODES[message] || code || '')) || message
  if (!/[가-힣]/.test(result)) return UNKNOWN_MESSAGE
  for (const [pattern, replacement] of TERMS) result = result.replace(pattern, replacement)
  return result
}

export function workMessage(value, permissionLevel) {
  return canViewWorkMessageDetails(permissionLevel) ? translate(value) : WORK_CONFIGURATION_ERROR
}

export function workToastPayload(payload, permissionLevel) {
  if (!['warning', 'error'].includes(payload.type)) return payload
  const message = typeof payload.title === 'string' && /[가-힣]/.test(payload.title)
    ? payload.title
    : payload.workError || payload.title
  return { ...payload, title: workMessage(message, permissionLevel) }
}

export function workNotice(value, record, permissionLevel) {
  const kind = [record?.event_type, record?.type, record?.severity, record?.level, record?.status, record?.group?.event_type].filter(Boolean).join(' ')
  return /(?:^|[_.\s-])(?:failed|failure|error|warning|blocked)(?:$|[_.\s-])/i.test(kind) || record?.error
    ? workMessage(value, permissionLevel)
    : value
}

// Diagnostic snapshots may contain errors alongside ordinary business data.
// Format only diagnostic fields; never mutate API data or user-entered reasons.
export function workDiagnosticData(value, permissionLevel) {
  if (Array.isArray(value)) return value.map(item => workDiagnosticData(item, permissionLevel))
  if (!value || typeof value !== 'object') return value
  if (['error', 'warning'].includes(value.severity || value.level) || (value.message && /^(?:RUNTIME|WORK|RPA|BRANCH|JOIN)_/.test(value.code || value.error_code || ''))) {
    if (!canViewWorkMessageDetails(permissionLevel)) return WORK_CONFIGURATION_ERROR
    return { ...value, message: workMessage(value, permissionLevel), ...(value.suggestion ? { suggestion: workMessage(value.suggestion, permissionLevel) } : {}) }
  }
  return Object.fromEntries(Object.entries(value).map(([key, entry]) => {
    if (/^(?:error|errors|warning|warnings|error_message|error_code|error_details|normalization_warnings|dispatch_warnings|non_field_errors)$/.test(key) && entry) {
      const format = item => workMessage(item, permissionLevel)
      return [key, Array.isArray(entry) ? entry.map(format) : format(entry)]
    }
    return [key, workDiagnosticData(entry, permissionLevel)]
  }))
}
